import { type ObjectValuesUnionType } from '../utils/typing';

export const BetslipStatuses = Object.freeze({
  SETTLED: 'SETTLED',
  CASHOUT: 'CASHOUT',
  RUNNING: 'RUNNING',
});

export type BetslipStatus = ObjectValuesUnionType<typeof BetslipStatuses>;

export const BetslipDisplayStatuses = Object.freeze({
  WINNING: 'WINNING',
  LOST: 'LOST',
  CANCELLED: 'CANCELLED',
  RUNNING: 'RUNNING',
  CASHOUT: 'CASHOUT',
});

export type BetslipDisplayStatus = ObjectValuesUnionType<typeof BetslipDisplayStatuses>;
